// extracted by mini-css-extract-plugin
export var addWidgetButton = "_x-6";
export var backButton = "_x-1";
export var legacyWidgetContainer = "_x-5";
export var pageContainer = "_x-2";
export var settingsContent = "_x-0";
export var widgetSubsectionItem = "_x-3";
export var widgetSubsectionItemContent = "_x-4";